<ng-container *ngIf="kkmForm">
  <div class="ui-kit-blocks-list--with-separator">
    <div class="ui-kit-rows-layout">
      <tax-input
        [layoutColumns]="2"
        [required]="true"
        labelText="kkm.registration.name.input"
        placeholder="kkm.registration.name.placeholder"
        id="title"
        [(ngModel)]="kkmForm.kkmInternalName"
        [tabindex]="1"
        [autofocus]="true"
        [clearable]="true"
        data-qa-input="kkm-name"
      ></tax-input>

      <div class="ui-kit-layout-columns-2" data-qa-select="kkm-model">
        <label for="model" class="required-marker" translate data-qa="label-text"
          >kkm.registration.model.input</label
        >
        <tax-search-dropdown-list
          id="model"
          [data]="kkmModels"
          placeholder="kkm.registration.model.placeholder"
          [currentItem]="kkmForm?.kkmModel"
          [scrollable]="true"
          [isInfinite]="true"
          (submittedData)="selectedModel($event)"
          data-qa="select"
        ></tax-search-dropdown-list>
      </div>

      <tax-input
        [layoutColumns]="2"
        [required]="true"
        labelText="kkm.settings.serial.factory.number"
        id="serialNumb"
        [(ngModel)]="kkmForm.kkmSerialNumber"
        placeholder="kkm.settings.serial.number.placeholder"
        [maxlength]="20"
        [tabindex]="2"
        [inputStyles]="'max-width: 200px'"
        data-qa-input="kkm-serial-number"
      ></tax-input>

      <div class="ui-kit-layout-columns-2" data-qa-input="kkm-year">
        <label for="year" class="required-marker" translate data-qa="label-text"
          >kkm.settings.year</label
        >
        <div
          class="tooltips"
          [ngClass]="{ invalid: kkmForm.kkmYear && !isYearValid(kkmForm.kkmYear) }"
        >
          <div tabindex="0" class="search__input">
            <input
              id="year"
              [(ngModel)]="kkmForm.kkmYear"
              class="text_field year"
              maxlength="4"
              placeholder="{{ 'kkm.setting.year' | translate }}"
              tabindex="3"
              taxNumbersOnly
              data-qa="input"
            />
          </div>
          <div class="tooltips-text" data-qa="error-text">
            {{
              (kkmForm.kkmYear <= 2015 ? 'kkm.year.smaller.warning' : 'kkm.year.bigger.warning')
                | translate
            }}
          </div>
        </div>
      </div>

      <div class="ui-kit-layout-columns-2" data-qa-select="retail-place">
        <label for="retailPlace" class="required-marker" translate data-qa="label-text"
          >kkm.settings.in.retail.place</label
        >
        <tax-search-dropdown-list
          id="retailPlace"
          [data]="retailPlaces"
          placeholder="search.dropdown.retail.place.placeholder"
          [currentItem]="kkmForm?.retailPlaceTitle"
          [scrollable]="true"
          (submittedData)="selectedRetailPlace($event)"
          data-qa="select"
        ></tax-search-dropdown-list>
      </div>
      <tax-input
        *ngIf="isChangingOfd"
        taxNumbersOnly
        id="registartionNumber"
        labelText="kkm.registration.number.kgd"
        placeholder="kkm.settings.registration.number.placeholder"
        data-qa-input="kkm-registration-number"
        inputStyles="max-width: 200px"
        [(ngModel)]="kkmForm.kkmRegId"
        [layoutColumns]="2"
        [maxlength]="12"
        [required]="true"
      ></tax-input>
    </div>

    <div class="ui-kit-rows-layout subscribe-block">
      <div class="ui-kit-layout-columns-2" *ngIf="!selectedTariff">
        <span class="ui-kit-layout-columns-2__centering" data-qa="tariff-title">{{
          'tariffs.subscribe' | translate
        }}</span>
        <div class="ui-kit-centering-string">
          <button
            class="button_blue"
            (click)="showTariffsModal()"
            translate
            data-qa-button="select-tariff"
          >
            tariffs.subscribe.select
          </button>
          <tax-icon name="long-arrow" width="46px" height="16px" class="arrow-icon"></tax-icon>
        </div>
      </div>
      <ng-container *ngIf="selectedTariff">
        <div class="ui-kit-layout-columns-2">
          <span data-qa="tariff-title">{{ 'tariffs.subscribe' | translate }}</span>
          <div>
            <span data-qa="selected-tariff-name">
              {{ selectedTariff.name }}
            </span>
            <span class="tariff-price" data-qa="selected-tariff-price">
              {{ selectedTariff | tariffPrice | kzCurrency }}
              {{ 'tariffs.period.MONTH' | translate }}
            </span>
            <button
              (click)="showTariffsModal()"
              data-qa-button="change-tariff"
              class="action-button ui-kit-button_link"
              translate
            >
              button.change
            </button>
            <button
              (click)="unselectTariff()"
              data-qa-button="delete-tariff"
              class="action-button ui-kit-button_link"
              translate
            >
              button.remove
            </button>
          </div>
        </div>
        <div class="ui-kit-layout-columns-2">
          {{ 'tariffs.connection.type' | translate }}:
          <div>
            {{
              ($any(selectedTariff)?.connectionType.connection === 'WIRED'
                ? 'tariffs.connection.type.wired'
                : 'tariffs.connection.type.wireless'
              ) | translate
            }}
          </div>
        </div>
        <tax-input
          [layoutColumns]="2"
          labelText="tariff.select.promo.code.label"
          [(ngModel)]="kkmForm.billingPromoCode"
          [inputStyles]="'max-width: 300px'"
          [disabled]="true"
          data-qa-input="promo-code"
          mask="AAAAA-AAAAA-AAAAA-AAAAA-AAAAA"
        ></tax-input>
      </ng-container>
    </div>

    <div class="confirmation" data-qa-checkbox="confirm">
      <input id="confirm" type="checkbox" [(ngModel)]="isConfirmed" data-qa="input" />
      <label for="confirm" class="confirmation__text" translate data-qa="label-text"
        >kkm.action.confirmation</label
      >
    </div>
  </div>

  <div class="ui-kit-bottom-buttons-block">
    <button class="back-button" (click)="back()" data-qa-button="go-back">
      {{ 'group.back' | translate }}
    </button>
    <div>
      <button
        class="button_blue"
        data-qa-button="save-kkm"
        [disabled]="!isFormValid()"
        (click)="processKkmForm(false)"
      >
        {{ 'button.save' | translate }}
      </button>
      <button
        class="button_blue"
        data-qa-button="go-to-sign"
        [disabled]="!isFormValid()"
        (click)="processKkmForm(true)"
      >
        {{ 'button.continue' | translate }}
      </button>
    </div>
  </div>
</ng-container>
